import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { getAddSubUserForm } from './AddSubUserENTForm.schema';
import { useMutation, useQueryClient } from 'react-query';
import { addSubUserFormData } from './AddSubUserENTForm.data';
import { ADD_SUB_USER_ENT_QUERY_KEY, addSubUserENTQuery } from './AddSubUserENTForm.query';
import Form from '../../../../../../commons/Form/Form';
import { AddSubUserFormSchema } from './AddSubUserENTForm.types';
import Loading from '../../../../../../commons/Loading/Loading';
import { useNavigate } from 'react-router-dom';
import { BaseResponse } from '../../../../../../../types/api/api.types';
import { useMemo } from 'react';
import { getSubUserRightLabel, subUserENTRightsList } from '../../../../../../../utils/helpers/user/getSubUserRightLabel';

export default () => {
  const navigate = useNavigate()
  
  const queryClient = useQueryClient()

  const formProps = useForm<AddSubUserFormSchema>({
    resolver: yupResolver(getAddSubUserForm),
    mode: 'onChange',
    reValidateMode: 'onChange'
  })

  const {
    handleSubmit
  } = formProps;

  const {
    mutate,
    isLoading
  } = useMutation<Awaited<BaseResponse>, Error, AddSubUserFormSchema>(
    (data) => addSubUserENTQuery(data),
    {
      mutationKey: ADD_SUB_USER_ENT_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: () => {
        navigate(0)
      },
      onError: (error) => alert(error.message),
    }
  )

  const updatedFormData = useMemo(
    () => ([
      ...addSubUserFormData,
      ...subUserENTRightsList.map((key, index) => [{
        name: key,
        type: 'checkbox',
        label: getSubUserRightLabel(index + 1),
      }])
    ]),
    [addSubUserFormData]
  )

  const onSubmit = handleSubmit((data) => mutate({...data}))

  if (isLoading) return <Loading />

  return (
    <Form<AddSubUserFormSchema>
      // @ts-ignore
      data={updatedFormData}
      {...{ formProps, onSubmit }}
      isCompany
    />
  )
}